import React from 'react';
import { useHistory } from 'react-router-dom';
import { featureEnabled } from 'utils';
import { AuthContext } from 'contexts';
import type { MenuProps } from 'antd';

import Icon from '../../Icon';
import { StyledMenu } from '../StyledComponents';
import { StyledMenuProps } from './types';

type MenuItem = Required<MenuProps>['items'][number];
type MenuItemWithDataCy = MenuItem & {
  'data-cy': string;
};

const MLSStaffMenu: React.FC<StyledMenuProps> = ({
  selectedKey,
  disableToolTip,
  getIconColor,
}) => {
  const { auth } = React.useContext(AuthContext);
  const features = auth?.org.features;
  const history = useHistory();
  const menuItems: MenuItemWithDataCy[] = [];
  let menuItemKey = 0;
  if (features.includes('MLS_STAFF_MANAGE_USERS')) {
    menuItems.push({
      key: `${menuItemKey}`,
      icon: (
        <Icon
          type={'antdUserOutlined'}
          color={getIconColor(`${menuItemKey}`) ?? undefined}
        />
      ),
      label: 'Users',
      onClick: () => history.push(`/mls/users`),
      'data-cy': 'side-menu-users',
    });
    menuItemKey += 1;
  }

  if (features.includes('MLS_STAFF_MANAGE_LOCKBOXES')) {
    menuItems.push({
      key: `${menuItemKey}`,
      icon: (
        <Icon
          type={'antdUnlockFilled'}
          color={getIconColor(`${menuItemKey}`) ?? undefined}
        />
      ),
      label: 'Lockboxes',
      onClick: () => history.push(`/mls/lockboxes`),
      'data-cy': 'side-menu-lockboxes',
    });
    menuItemKey += 1;
  }

  if (features.includes('MLS_STAFF_MANAGE_BROKERAGES')) {
    menuItems.push({
      key: `${menuItemKey}`,
      icon: (
        <Icon
          type={'antdBankOutlined'}
          color={getIconColor(`${menuItemKey}`) ?? undefined}
        />
      ),
      label: 'Brokerages',
      onClick: () => history.push(`/mls/brokerages`),
      'data-cy': 'side-menu-brokerages',
    });
    menuItemKey += 1;
  }

  if (
    features.includes('MLS_STAFF_QUICK_LOCKBOX_ASSIGNMENT') &&
    featureEnabled('quickLockboxAssignmentFeature')
  ) {
    menuItems.push({
      key: `${menuItemKey}`,
      icon: (
        <Icon
          type={'assignmentAddOutlined'}
          color={getIconColor(`${menuItemKey}`) ?? undefined}
        />
      ),
      label: 'Quick Assignment',
      onClick: () => history.push(`/mls/quick-assignment`),
      'data-cy': 'side-menu-quick-assignment',
    });
    menuItemKey += 1;
  }

  if (
    features.includes('MLS_STAFF_VIEW_CONTRACTS') &&
    featureEnabled('supraBillingApiFeature')
  ) {
    menuItems.push({
      key: `${menuItemKey}`,
      icon: (
        <Icon
          type={'antdFileTextOutlined'}
          color={getIconColor(`${menuItemKey}`) ?? undefined}
        />
      ),
      label: 'Contracts',
      onClick: () => history.push(`/mls/contracts`),
      'data-cy': 'side-menu-contracts',
    });
    menuItemKey += 1;
  }

  if (features.includes('ADMIN')) {
    menuItems.push({
      key: `${menuItemKey}`,
      icon: (
        <Icon type="tool" color={getIconColor(`${menuItemKey}`) ?? undefined} />
      ),
      label: disableToolTip ? null : 'Settings',
      onClick: () => history.push(`/answering/settings`),
      'data-cy': 'side-menu-settings',
    });
    menuItemKey += 1;
  }

  return (
    <StyledMenu mode="inline" selectedKeys={[selectedKey]} items={menuItems} />
  );
};

export default MLSStaffMenu;
